import { render, staticRenderFns } from "./VotingResults.vue?vue&type=template&id=30435fee"
import script from "./VotingResults.vue?vue&type=script&lang=js"
export * from "./VotingResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports